import { useSelector, useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { openBankModal } from '../../../../../app/store/slices/bank/bank';
import AddBankDetail from './AddBankDetail';
import AddedBankList from './AddedBankList';

function BankDetail() {
    const dispatch = useDispatch();
    const { openAddBankModal } = useSelector((state) => state.bank);

    return (
        <div className="user-profile-main-container">
            <div className="add-bank-detail-button">
                <Button variant="main" onClick={() => dispatch(openBankModal(true))}>
                    Add Bank Details
                </Button>
            </div>
            <div className="user-profile-container">
                <AddedBankList />
            </div>
            {openAddBankModal && <AddBankDetail onClose={() => dispatch(openBankModal(false))} />}
        </div>
    );
}

export default BankDetail;
